/* eslint-disable */
// แก้บรรทัดนี้
import React, { useEffect, useState, useMemo, useRef } from 'react';
import './CookieConsent.css';
import {
  Cookie as CookieIcon,
  Tune as TuneIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  Security as SecurityIcon,
  Layers as LayersIcon,
  PieChart as PieChartIcon,
  Campaign as CampaignIcon,
  Badge as BadgeIcon,
  Gavel as GavelIcon, // ไอคอนสำหรับนโยบายทั่วไป
  Description as DescriptionIcon, // ไอคอนสำหรับนโยบายพนักงาน
  ArrowForwardIos as ArrowIcon,
} from '@mui/icons-material';
import { useCookies } from 'react-cookie';
import { useDataContext } from '../../context';
import { jwtDecode } from 'jwt-decode';
// --- เนื้อหา HTML สำหรับนโยบายทั่วไป (ตัดมาเฉพาะส่วนเนื้อหา) ---
const GENERAL_POLICY_CONTENT = `
  <!doctype html>
<html lang="en">

<head>

    
<script async src="https://www.googletagmanager.com/gtag/js?id=G-4Z4N2V1ETF"></script>
<script>
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', 'G-4Z4N2V1ETF');
</script>

<script>
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-PKZ9Q97C');
</script>
<script>
    ! function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1471545663520952');
    fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1471545663520952&ev=PageView&noscript=1" /></noscript>
<script>
    ! function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1482429759066311');
    fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1482429759066311&ev=PageView&noscript=1" /></noscript>
<script>
    ! function(w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"], ttq.setAndDefer = function(t, e) {
            t[e] = function() {
                t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
            }
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function(t) {
            for (
                var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
            return e
        }, ttq.load = function(e, n) {
            var r = "https://analytics.tiktok.com/i18n/pixel/events.js",
                o = n && n.partner;
            ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
            n = document.createElement("script");
            n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t;
            e = document.getElementsByTagName("script")[0];
            e.parentNode.insertBefore(n, e)
        };


        ttq.load('CSKPE3RC77UBLI99THT0');
        ttq.page();
    }(window, document, 'ttq');
</script>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>บุญศิริโฟรเซ่นโปรดักส์</title>

<meta property="og:url" content="https://www.boonsiri.co.th/%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="บุญศิริโฟรเซ่นโปรดักส์" />
<meta property="og:description" content="บุญศิริโฟรเซ่นโปรดักส์" />
<meta property="og:image" content="https://www.boonsiri.co.th/meta/1717403864-0.png" />
<meta property="og:locale" content="th_TH">
<meta property="og:site_name" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta property="fb:app_id" content="197604500692653" />
<meta property="fb:page_id" content="197604500692653" />
<meta property="fb:pages" content="197604500692653">
<meta property="ia:markup_url" content="https://www.boonsiri.co.th/%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5/">
<meta property="ia:rules_url" content="https://www.boonsiri.co.th/%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5/">

<meta name="keywords" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta name="title" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta name="description" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta name="author" content="บุญศิริโฟรเซ่นโปรดักส์">

<meta name="twitter:card" content="summary_large_image">
<meta name="twitter:description" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta name="twitter:title" content="บุญศิริโฟรเซ่นโปรดักส์">
<meta name="twitter:image" content="https://www.boonsiri.co.th/meta/1717403864-0.png">

<meta name="robots" content="index,follow" />
<meta name="googlebot" content="index,follow" />
<meta name="googlebot-news" content="index,follow" />

<link rel="canonical" href="https://www.boonsiri.co.th/%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%84%E0%B8%B8%E0%B9%89%E0%B8%A1%E0%B8%84%E0%B8%A3%E0%B8%AD%E0%B8%87%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%84%E0%B8%A5/" />

<meta name="language" content="th-TH" />
<meta name="distribution" content="Global" />
<meta name="rating" content="General" />
<meta name="creator" content="บุญศิริโฟรเซ่นโปรดักส์" />
<meta name="publisher" content="บุญศิริโฟรเซ่นโปรดักส์" />

<link rel="apple-touch-icon" sizes="57x57" href="https://www.boonsiri.co.th/favicon/apple-icon-57x57.png">
<link rel="apple-touch-icon" sizes="60x60" href="https://www.boonsiri.co.th/favicon/apple-icon-60x60.png">
<link rel="apple-touch-icon" sizes="72x72" href="https://www.boonsiri.co.th/favicon/apple-icon-72x72.png">
<link rel="apple-touch-icon" sizes="76x76" href="https://www.boonsiri.co.th/favicon/apple-icon-76x76.png">
<link rel="apple-touch-icon" sizes="114x114" href="https://www.boonsiri.co.th/favicon/apple-icon-114x114.png">
<link rel="apple-touch-icon" sizes="120x120" href="https://www.boonsiri.co.th/favicon/apple-icon-120x120.png">
<link rel="apple-touch-icon" sizes="144x144" href="https://www.boonsiri.co.th/favicon/apple-icon-144x144.png">
<link rel="apple-touch-icon" sizes="152x152" href="https://www.boonsiri.co.th/favicon/apple-icon-152x152.png">
<link rel="apple-touch-icon" sizes="180x180" href="https://www.boonsiri.co.th/favicon/apple-icon-180x180.png">
<link rel="icon" type="image/png" sizes="192x192" href="https://www.boonsiri.co.th/favicon/android-icon-192x192.png">
<link rel="icon" type="image/png" sizes="32x32" href="https://www.boonsiri.co.th/favicon/favicon-32x32.png">
<link rel="icon" type="image/png" sizes="96x96" href="https://www.boonsiri.co.th/favicon/favicon-96x96.png">
<link rel="icon" type="image/png" sizes="16x16" href="https://www.boonsiri.co.th/favicon/favicon-16x16.png">
<link rel="manifest" href="https://www.boonsiri.co.th/favicon/manifest.json">
<meta name="msapplication-TileColor" content="#65b7d6">
<meta name="msapplication-TileImage" content="https://www.boonsiri.co.th/favicon/ms-icon-144x144.png">
<meta name="theme-color" content="#65b7d6">

<link rel="stylesheet" href="https://www.boonsiri.co.th/bootstrap/css/bootstrap.min.css">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA==" crossorigin="anonymous" referrerpolicy="no-referrer" />
<link rel="stylesheet" href="https://www.boonsiri.co.th/style-theme.css">
<link rel="stylesheet" href="https://www.boonsiri.co.th/style-desktop.css">
<link rel="stylesheet" href="https://www.boonsiri.co.th/style-tablet.css">
<link rel="stylesheet" href="https://www.boonsiri.co.th/style-mobile.css">
<link rel="stylesheet" href="https://www.boonsiri.co.th/select2/css/select2.min.css" />
    <style>
        ol {
            list-style-type: none;
            counter-reset: item;
            margin: 0;
            padding: 0;
        }

        ol>li {
            display: table;
            counter-increment: item;
            margin-bottom: 0.6em;
        }

        ol>li:before {
            content: counters(item, ".") ". ";
            display: table-cell;
            padding-right: 0.6em;
        }

        li ol>li {
            margin: 0;
        }

        li ol>li:before {
            content: counters(item, ".") " ";
        }
    </style>

</head>

<body>

    
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PKZ9Q97C" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<nav class="navbar navbar-expand-lg py-0 sticky-top shadow" id="HeaderMenu">
    <div class="container-fluid">
        <div class="row w-100 mx-0">
  
            <div class="col-12 col-lg-auto my-auto ms-auto">
                
            </div>
                
            
            <div class="col-12 col-lg-auto ms-auto mt-3 mt-lg-auto mb-0 mb-lg-auto d-none d-lg-block">
            </div>
                
            
        </div>
    </div>
</nav>


<div class="mobile-menu d-block d-lg-none shadow">
    <div class="row mx-0">
        
            
            <div class="col px-0">
                </div>
                
            
    </div>
</div>

    <section class="py-2">
        <div class="container">
            <div class="row">
                <div class="col">
                    <h2 class="mb-4">นโยบายทั่วไป</h2>
                    <h3 class="mb-4">เรื่อง การคุ้มครองข้อมูลส่วนบุคคลและการรักษาความปลอดภัยภายในองค์กร</h3>
                    <p>เพื่อให้การดำเนินงานของ บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด และบริษัทฯ ในเครือ เป็นไปตาม พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และกฎหมายที่เกี่ยวข้อง ตลอดจนเพื่อสร้างมาตรการด้านความปลอดภัย ป้องกันความเสี่ยงจากการรั่วไหลหรือถูกเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต อีกทั้งรักษาภาพลักษณ์องค์กร บริษัทฯ จึงได้มีการกำหนด นโยบายทั่วไป ไว้ดังต่อไปนี้</p>
                    
                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">1. ข้อมูลส่วนบุคคลและข้อมูลอ่อนไหว</h4>
                    <p>บริษัทฯ จะเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคลของพนักงานเพื่อวัตถุประสงค์ที่เกี่ยวข้องกับการทำงานเท่านั้น</p>
                    <p>พนักงานทุกฝ่ายต้อง <strong>ขีดฆ่าช่องข้อมูลอ่อนไหว (ศาสนา)</strong> ด้วยปากกาสีดำหรือน้ำเงินบนเอกสารสำคัญ เช่น บัตรประชาชน ก่อนจัดเก็บ เพื่อป้องกันการใช้เกินความจำเป็น ไม่ว่าจะเป็นเอกสารของพนักงาน คู่ค้า ลูกค้า หรือผู้ที่มีส่วนเกี่ยวข้องกับบริษัท</p>
                    <p>พนักงานมีสิทธิได้รับการคุ้มครองข้อมูลส่วนบุคคลตามกฎหมาย แต่ต้องให้ความร่วมมือกับบริษัทในการใช้ข้อมูลเท่าที่จำเป็นต่อการปฏิบัติงาน</p>
                    <p>บริษัท มีการดำเนินการตรวจหาสารเสพติดหรือวัดระดับแอลกอฮอล์ในร่างกายของพนักงานโดยไม่จำเป็นต้องแจ้งพนักงานล่วงหน้า เพื่อความปลอดภัยและปฏิบัติตามกฎหมาย ทั้งนี้ผลตรวจถือเป็น <strong>ข้อมูลส่วนบุคคลอ่อนไหว</strong> บริษัทฯ จะใช้และเก็บรักษาเฉพาะวัตถุประสงค์ด้านความปลอดภัยเท่านั้น</p>

                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">2. การใช้ภาพถ่ายและวิดีโอของพนักงานในกิจกรรมองค์กร</h4>
                    <p>บริษัทฯ อาจมีการถ่ายภาพหรือบันทึกวิดีโอในกิจกรรมต่าง ๆ เพื่อใช้ในการประชาสัมพันธ์หรือการสื่อสาร ทั้งภายในและภายนอกองค์กร ซึ่งการเข้าร่วมกิจกรรมถือว่า <strong>พนักงานได้ให้ความยินยอมโดยปริยาย</strong> ในการใช้ภาพถ่ายหรือวิดีโอดังกล่าวในช่วงที่ยังเป็นพนักงานของบริษัทฯ อย่างไรก็ตาม การนำไปเผยแพร่ภายนอกจะต้องได้รับอนุมัติจากหน่วยงานที่เกี่ยวข้องก่อนทุกครั้ง</p>
                    <p>พนักงานทุกคน ควรหลีกเลี่ยงการถ่ายหรือเผยแพร่ภาพและวิดีโอของบุคคลภายนอก โดยไม่ได้รับความยินยอมจากบุคคลนั้นก่อนหรือจากหน่วยงานที่เกี่ยวข้อง สำหรับพนักงานฝ่ายขนส่ง ฝ่ายขาย หรือผู้ที่ต้องพบลูกค้าโดยตรง ก็ควรระมัดระวัง ไม่ถ่ายภาพหรือบันทึกวิดีโอของลูกค้า ขณะส่งสินค้า หรือเข้าพบลูกค้า</p>
                    <p>ในกรณีที่จำเป็นต้องถ่ายภาพหรือบันทึกวิดีโอเพื่อทำคอนเทนต์หรือกิจกรรมของบริษัท ต้องได้รับความยินยอมจากลูกค้าก่อน และหากต้องเผยแพร่ ควร <strong>เบลอหน้าหรือปกปิดข้อมูลส่วนบุคคล</strong> ของบุคคลภายนอกเพื่อปกป้องความเป็นส่วนตัว และให้เป็นไปตาม <strong>กฎหมายคุ้มครองข้อมูลส่วนบุคคล (PDPA)</strong></p>
                    <p><strong>ข้อยกเว้น:</strong> เมื่อพนักงานพ้นสภาพจากการเป็นพนักงาน บริษัทฯ จะงดเว้นการนำภาพถ่ายหรือวิดีโอที่เกี่ยวข้องไปใช้หรือเผยแพร่ต่อไป เพื่อปกป้องสิทธิส่วนบุคคลและความเป็นส่วนตัวของอดีตพนักงาน เว้นแต่กรณีที่บุคคลดังกล่าวได้ให้ความยินยอมเป็นลายลักษณ์อักษรแก่บริษัทฯ</p>

                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">3. การให้ข้อมูลส่วนบุคคลกับธนาคาร/สถาบันการเงิน</h4>
                    <p>พนักงานต้อง <strong>แจ้งความยินยอมล่วงหน้ากับฝ่ายบุคคล (HR)</strong> ก่อนที่บริษัทจะให้ข้อมูลส่วนบุคคลหรือข้อมูลการทำงานใด ๆ แก่ธนาคารหรือสถาบันการเงิน ไม่ว่าจะเป็นการสมัครบัตรเครดิต, ขอสินเชื่อ, การกู้ยืม หรือกรณีอื่น ๆ ที่พนักงานไปสมัครด้วยตนเอง การแจ้งความยินยอมช่วยให้บริษัท ดำเนินการยืนยันข้อมูลได้รวดเร็ว ถูกต้อง และให้ข้อมูลเฉพาะที่จำเป็นตามวัตถุประสงค์ที่พนักงานอนุญาตเท่านั้น</p>

                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">4. การใช้งานอุปกรณ์และระบบของบริษัท</h4>
                    <p>การเข้าถึงระบบงานหรือแพลตฟอร์มของบริษัทผ่านอุปกรณ์ส่วนตัว ต้องเป็นไปตามมาตรการรักษาความปลอดภัยของบริษัท เพื่อป้องกันการรั่วไหล สูญหาย หรือถูกเข้าถึงโดยไม่ได้รับอนุญาต</p>
                    <p>พนักงานที่นำอุปกรณ์ส่วนตัวมาเชื่อมต่อกับระบบของบริษัท ต้องปฏิบัติตามมาตรการด้านความปลอดภัย เช่น การตั้งรหัสผ่าน การเข้ารหัสข้อมูล และใช้ซอฟต์แวร์ที่ได้รับอนุญาตเท่านั้น ห้ามติดตั้งหรือใช้ซอฟต์แวร์ที่ไม่ได้รับอนุญาตร่วมกับระบบบริษัทโดยเด็ดขาด</p>
                    <p>พนักงานต้องรักษาความปลอดภัยของบัญชีผู้ใช้ (User Account) และรหัสผ่านของตนเอง ไม่เปิดเผยหรือให้บุคคลอื่นเข้าถึงโดยไม่ได้รับอนุญาต</p>

                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">5. การรักษาภาพลักษณ์และความลับทางธุรกิจ</h4>
                    <p>พนักงานทุกคนต้องงดเว้นการแสดงความคิดเห็น การตอบโต้ หรือการเผยแพร่ข้อมูลบริษัทต่อสาธารณะ โดยอนุญาตให้ <strong>ฝ่ายสื่อสารองค์กร หรือผู้ที่ทำหน้าที่ในการสื่อสารองค์กร</strong> เป็นผู้ดำเนินการเท่านั้น</p>
                    <p>ห้ามนำข้อมูลทางธุรกิจ ข้อมูลเชิงกลยุทธ์ ลูกค้า คู่ค้า หรือข้อมูลใด ๆ ที่มีลักษณะเป็นความลับ ไปเปิดเผยหรือใช้ในลักษณะที่อาจก่อให้เกิดความเสียหายต่อบริษัท</p>

                    <hr class="my-5">

                    <h4 class="fw-bold fs-4">6. การควบคุมและตรวจสอบข้อมูล</h4>
                    <p>เพื่อให้การจัดการข้อมูลของบริษัทเป็นไปอย่างปลอดภัยและโปร่งใส แผนก <strong>เทคโนโลยีสารสนเทศ (IT)</strong> และ <strong>ตรวจสอบภายใน (Internal Audit: IA)</strong> มีสิทธิ์ในการเข้าถึงข้อมูลของพนักงาน เพื่อวัตถุประสงค์ด้านการตรวจสอบและการรักษาความปลอดภัย โดยสามารถดำเนินการได้โดยไม่จำเป็นต้องแจ้งให้พนักงานทราบล่วงหน้า</p>
                    <p>ทั้งนี้ การเข้าถึงข้อมูลจะอยู่ภายใต้หลัก <strong>“เท่าที่จำเป็น” (Need-to-know basis)</strong> หมายความว่า บุคลากรที่ได้รับอนุญาตให้เข้าถึงข้อมูล จะเข้าถึงได้เฉพาะข้อมูลที่เกี่ยวข้องกับหน้าที่งานหรือวัตถุประสงค์ที่ชัดเจนเท่านั้น ไม่ใช่การเข้าถึงข้อมูลทั้งหมดอย่างไม่มีขอบเขต</p>
                    <p>เมื่อพนักงานพ้นสภาพจากการเป็นพนักงานแล้ว บริษัทฯ ขอความร่วมมือ <strong>ห้ามนำภาพถ่าย วิดีโอ หรือข้อมูลใด ๆ ของอดีตพนักงานไปเผยแพร่บนสื่อสังคมออนไลน์หรือสื่อสาธารณะ</strong> นับตั้งแต่วันสิ้นสุดการจ้างเป็นต้นไป</p>

                    <h5 class="fw-bold mt-4">เหตุผลและความสำคัญ</h5>
                    <ul class="list-unstyled">
                        <li>- เพื่อ <strong>ปกป้องสิทธิส่วนบุคคล</strong> ของอดีตพนักงานตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล (PDPA)</li>
                        <li>- เพื่อ <strong>รักษาความเป็นส่วนตัว</strong> ของบุคคลที่ไม่ได้มีความเกี่ยวข้องกับบริษัทฯ อีกต่อไป</li>
                        <li>- เพื่อป้องกันความเข้าใจผิด ความเสียหายต่อชื่อเสียง หรือการนำข้อมูลไปใช้ในทางที่ไม่เหมาะสม</li>
                    </ul>

                    <p class="mt-4 text-danger fw-bold">ในกรณีที่พนักงานรายใดฝ่าฝืนข้อกำหนดของบริษัทฯ หรือพบว่ากระทำการที่ไม่เป็นไปตามกฎระเบียบที่บริษัทฯ กำหนด บริษัทฯ มีสิทธิ์พิจารณาและกำหนดบทลงโทษที่เหมาะสมตามดุลยพินิจของคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (DPO) โดยบทลงโทษดังกล่าวอาจรวมถึง แต่ไม่จำกัดเพียง การตักเตือนเป็นลายลักษณ์อักษร การพักงาน หรือการเลิกจ้าง ทั้งนี้เพื่อรักษาระเบียบวินัยและประโยชน์สูงสุดขององค์กร</p>

                </div>
            </div>
        </div>
    </section>
     


   

<script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script><script src="https://www.boonsiri.co.th/bootstrap/js/bootstrap.bundle.min.js"></script>
<script src="https://code.jquery.com/jquery-3.6.1.min.js" integrity="sha256-o88AwQnZB+VDvE9tvIXrMQaPlFFSUTR+nldQm1LuPXQ=" crossorigin="anonymous"></script>
<script src="https://www.boonsiri.co.th/sweetalert2.all.min.js"></script>
<script src="https://www.boonsiri.co.th/select2/js/select2.min.js"></script>


<div class="modal fade" id="ModalMemberRequired" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="ModalMemberRequiredLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-lg-down">
        <div class="modal-content">
            <div class="modal-header border-0">
                <h5 class="mb-0 modal-title">ลงชื่อเข้าใช้งานเพื่อดูสินค้า</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body border-0 d-flex">
                <img src="https://www.boonsiri.co.th/images/check-member.png" alt="Boonsiri Member" class="logo-login my-auto">
            </div>
            </div>
    </div>
</div>


<a href="https://lin.ee/ddCmohN" class="social-icon-widget widget-list shadow list-1 btn-tooltip" target="_blank" data-bs-title="แชทกับเราผ่าน LINE">
    <img src="https://www.boonsiri.co.th/images/cta-line.png" alt="บุญศิริโฟรเซ่นโปรดักส์">
</a>
<a href="https://m.me/197604500692653" class="social-icon-widget widget-list shadow list-2 btn-tooltip" target="_blank" data-bs-title="แชทกับเราผ่าน Messenger">
    <img src="https://www.boonsiri.co.th/images/cta-messenger.png" alt="บุญศิริโฟรเซ่นโปรดักส์">
</a>
<a href="https://www.tiktok.com/@boonsirifrozen" class="social-icon-widget widget-list shadow list-3 btn-tooltip" style="background-color: black;" target="_blank" data-bs-title="ติดตามเราที่ TikTok">
    <img src="https://www.boonsiri.co.th/images/cta-tiktok.svg" alt="บุญศิริโฟรเซ่นโปรดักส์">
</a>

<script>
    $("#CTAWidgetToggle").on("click", function() {
        $(".widget-list").toggleClass("active");
    });
</script>

</body>

</html>
`;

// --- เนื้อหา HTML สำหรับนโยบายพนักงาน (ตัดมาเฉพาะส่วนเนื้อหา) ---
const EMPLOYEE_POLICY_CONTENT = `
  <!doctype html>
<html lang="en">

<head>
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-4Z4N2V1ETF"></script>
    <script>
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', 'G-4Z4N2V1ETF');
    </script>

    <script>
        (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-PKZ9Q97C');
    </script>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>นโยบายความเป็นส่วนตัวสำหรับพนักงาน - บุญศิริโฟรเซ่นโปรดักส์</title>

    <meta property="og:type" content="website" />
    <meta property="og:title" content="นโยบายความเป็นส่วนตัวสำหรับพนักงาน" />
    <meta property="og:description" content="นโยบายความเป็นส่วนตัวสำหรับพนักงาน บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด" />
    <meta property="og:image" content="https://www.boonsiri.co.th/meta/1717403864-0.png" />
    <meta property="og:locale" content="th_TH">

    <link rel="stylesheet" href="https://www.boonsiri.co.th/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">
    <link rel="stylesheet" href="https://www.boonsiri.co.th/style-theme.css">
    <link rel="stylesheet" href="https://www.boonsiri.co.th/style-desktop.css">
    <link rel="stylesheet" href="https://www.boonsiri.co.th/style-tablet.css">
    <link rel="stylesheet" href="https://www.boonsiri.co.th/style-mobile.css">
    
    <style>
        ol { list-style-type: none; counter-reset: item; margin: 0; padding: 0; }
        ol > li { display: table; counter-increment: item; margin-bottom: 0.6em; }
        ol > li:before { content: counters(item, ".") ". "; display: table-cell; padding-right: 0.6em; font-weight: bold; }
        li ol > li { margin: 0; }
        li ol > li:before { content: counters(item, ".") " "; }
        h4 { margin-top: 2.5rem; margin-bottom: 1rem; color: #0d6efd; font-weight: bold; font-size: 1.4rem; border-bottom: 2px solid #f0f0f0; padding-bottom: 10px; }
        h5 { margin-top: 1.5rem; font-weight: bold; color: #333; }
        .table-custom th { background-color: #e9ecef; vertical-align: top; }
        .table-custom td { vertical-align: top; }
        .bg-contact { background-color: #f8f9fa; border-left: 5px solid #0d6efd; }
    </style>
</head>

<body>

<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PKZ9Q97C" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>

<nav class="navbar navbar-expand-lg py-0 sticky-top shadow" id="HeaderMenu">
    <div class="container-fluid">
        <div class="row w-100 mx-0">
            <div class="col-12 col-lg-auto my-auto ms-auto"></div>
        </div>
    </div>
</nav>

<section class="py-2">
    <div class="container">
        <div class="row">
            <div class="col">
                <p>บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด (ซึ่งต่อไปในนโยบายนี้ เรียกว่า “บริษัทฯ”) ให้ความสำคัญเป็นอย่างยิ่งกับการคุ้มครองข้อมูลส่วนบุคคลของพนักงานของบริษัทฯ และเพื่อให้มั่นใจได้ว่าบริษัทฯ จะให้ความคุ้มครองและปฏิบัติต่อข้อมูลส่วนบุคคลของท่าน โดยสอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ตลอดจนพระราชกฤษฎีกา กฎ ประกาศ ระเบียบ ข้อบังคับ ข้อปฏิบัติ มาตรการ แนวทางการดำเนินการ คำสั่ง ที่ออกตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล”) บริษัทฯ จึงได้จัดทำนโยบายความเป็นส่วนตัวสำหรับสำหรับพนักงาน และบุคคลอื่นที่เกี่ยวข้องฉบับนี้ขึ้น (“นโยบาย”) เพื่อแจ้งให้ท่านทราบถึงรายละเอียดการดำเนินการกับข้อมูลส่วนบุคคลไม่ว่าจะเป็นการเก็บรวบรวม ใช้ และเปิดเผย (ต่อไปเรียกว่า “การประมวลผลข้อมูล” หรือ “การประมวลผลข้อมูลส่วนบุคคล”) ซึ่งอาจเกิดขึ้น ตลอดจนแจ้งให้ท่านทราบถึงสิทธิในข้อมูลส่วนบุคคลของท่าน และช่องทางการติดต่อบริษัทฯ ดังต่อไปนี้</p>

                <h4>1. ความหมาย</h4>
                <ul>
                    <li><strong>“พนักงาน”</strong> หมายถึง พนักงานตามความหมายตามข้อบังคับการบริหารงานบุคคล ระเบียบและแนวปฏิบัติ การบริหารงานบุคคลของบริษัทฯ</li>
                    <li><strong>“บุคคลที่เกี่ยวข้อง”</strong> หมายถึง บุคคลในครอบครัวของพนักงาน หรือบุคคลอื่นซึ่งพนักงานได้ให้ข้อมูลส่วนบุคคลไว้กับบริษัทฯ อันได้แก่ บุคคลอ้างอิง ผู้รับผลประโยชน์ เป็นต้น</li>
                    <li><strong>“ท่าน”</strong> หมายถึง พนักงานและบุคคลที่เกี่ยวข้อง</li>
                </ul>

                <h4>2. แหล่งที่มาของข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวม</h4>
                <p>บริษัทฯ เก็บรวบรวมและใช้ข้อมูลส่วนบุคคลหลากหลายประเภท โดยประเภทของข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวมนั้นขึ้นอยู่กับสถานการณ์และเหตุการณ์ที่แตกต่างกันออกไปตามกระบวนการบริหารทรัพยากรบุคคลของบริษัทฯ โดยบริษัทฯ มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลที่หลากหลาย ได้แก่</p>
                
                <h5>2.1 แหล่งที่มาของข้อมูลส่วนบุคคลที่บริษัทฯ ได้รับจากท่านโดยตรง เช่น</h5>
                <ul>
                    <li>จากขั้นตอนการสมัครเข้าทำงานและการจ้างงาน การยื่นใบสมัคร การแนบเอกสารประกอบขั้นตอนการคัดเลือกหรือการลงทะเบียนใดๆ ที่เกี่ยวข้องกับขั้นตอนการสรรหาบุคลากรของบริษัทฯ</li>
                    <li>จากการดำเนินการตามสัญญาจ้างแรงงานและเอกสารประกอบที่แนบมาพร้อมกัน หรือการจดทะเบียนใดๆ ที่เกี่ยวข้องกับกระบวนการทำงานภายในของบริษัทฯ</li>
                    <li>จากการประสานงานร่วมกันระหว่างท่านและพนักงานท่านอื่นๆ หรือบุคคลอื่นๆ ที่เกี่ยวข้องกับบริษัทฯ</li>
                    <li>จากการที่ท่านใช้ระบบ ศูนย์ข้อมูล เซิร์ฟเวอร์ ซอฟต์แวร์ แอปพลิเคชัน แพลตฟอร์ม หรือเครือข่ายใดๆ ของบริษัทฯ ในการปฏิบัติงาน</li>
                    <li>จากการมีส่วนร่วมของท่านต่อกิจกรรมของบริษัทฯ หรือสิทธิพิเศษและประโยชน์อื่นๆ ที่บริษัทฯ มอบให้ท่าน</li>
                    <li>จากการสื่อสารของท่านกับบริษัทฯ ผ่านช่องทางการติดต่อของบริษัทฯ เช่น โทรศัพท์ อีเมล ไลน์ (LINE) เฟสบุ๊ค (Facebook) Microsoft Teams หรือช่องทางอื่น ๆ ที่เกี่ยวข้อง</li>
                </ul>

                <h5>2.2 แหล่งที่มาของข้อมูลส่วนบุคคลที่บริษัทฯ ได้รับจากแหล่งอื่น เช่น</h5>
                <ul>
                    <li>จากบริษัทในเครือของบริษัทฯ</li>
                    <li>จากบุคคลอ้างอิง ผู้ติดต่อฉุกเฉิน หรือสมาชิกในครอบครัวของท่านที่ปรากฎตามสัญญาจ้างแรงงานและเอกสารประกอบที่เกี่ยวข้อง</li>
                    <li>จากเว็บไซต์รับสมัครงาน (Recruiter Website) ตัวแทนจัดหางาน (Headhunter) หรือจากพนักงานปัจจุบันของบริษัทฯ</li>
                    <li>จากผู้ให้บริการตรวจสอบประวัติการศึกษาและการทำงาน ข้อมูลเครดิต และข้อมูลประวัติอาชญากรรม</li>
                    <li>จากโรงพยาบาล คลินิก Lab หรืออื่นๆ ที่เกี่ยวข้องกับด้านสุขภาพ</li>
                    <li>จากหน่วยงานราชการ เช่น กรมการจัดหางาน</li>
                </ul>

                <h4>3. ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวม และวัตถุประสงค์</h4>
                <p>บริษัทฯ จะจัดเก็บข้อมูลส่วนบุคคลของพนักงานตามรายละเอียดข้อมูลด้านล่างนี้ ซึ่งหากพนักงานไม่ให้ข้อมูลส่วนบุคคลดังกล่าวจะส่งผลกระทบให้บริษัทฯ ไม่สามารถปฏิบัติให้เป็นไปตามสัญญาจ้างงาน เงื่อนไขการสมัครงาน กฎหมายแรงงาน และ/หรือกฎหมายอื่นใดที่เกี่ยวข้องได้</p>
                
                <h5>3.1 ข้อมูลส่วนบุคคลทั่วไปของพนักงาน</h5>
                <ul>
                    <li>ข้อมูลและเอกสารการสรรหา (Resume, ใบสมัครงาน)</li>
                    <li>ข้อมูลการติดต่อ (ที่อยู่, เบอร์โทร, อีเมล, Line ID)</li>
                    <li>ข้อมูลเฉพาะตัว (ชื่อ, นามสกุล, ชื่อเล่น, ลายมือชื่อ, สัญชาติ)</li>
                    <li>ข้อมูลคุณลักษณะบุคคล (วันเกิด, อายุ, เพศ, สถานภาพ, ภาระทางทหาร)</li>
                    <li>รูปถ่ายและภาพเคลื่อนไหว</li>
                    <li>ข้อมูลการศึกษาและความสามารถ</li>
                    <li>ข้อมูลประสบการณ์ทำงานและการจ้างงานในอดีต</li>
                    <li>ข้อมูลทางการเงิน (ค่าจ้าง, บัญชีธนาคาร, ภาษี, กองทุนสำรองเลี้ยงชีพ)</li>
                    <li>ข้อมูลประกันสังคมและสวัสดิการ</li>
                    <li>บันทึกการเข้าออกงานและการปฏิบัติงาน</li>
                    <li>รหัสพนักงานและประวัติการปฏิบัติงาน</li>
                    <li>ข้อมูลการใช้งานระบบสารสนเทศ (Log file, การเข้าถึงระบบ)</li>
                    <li>สำเนาเอกสารระบุตัวตน (บัตรประชาชน, ทะเบียนบ้าน, ใบขับขี่)</li>
                    <li>ข้อมูลเกี่ยวกับการร้องเรียนและการลงโทษทางวินัย</li>
                </ul>

                <h5>3.2 ข้อมูลส่วนบุคคลทั่วไปของบุคคลที่เกี่ยวข้องกับพนักงาน</h5>
                <ul>
                    <li>ข้อมูลของคู่สมรส บุตร บิดามารดา ผู้รับผลประโยชน์ หรือบุคคลติดต่อฉุกเฉิน ได้แก่ ชื่อ นามสกุล ที่อยู่ และเบอร์โทรศัพท์</li>
                </ul>

                <h5>3.3 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)</h5>
                <p>บริษัทฯ อาจเก็บรวบรวมข้อมูลอ่อนไหวโดยได้รับความยินยอมโดยชัดแจ้ง (เว้นแต่กฎหมายอนุญาตให้ทำได้โดยไม่ต้องขอความยินยอม) ได้แก่:</p>
                <ul>
                    <li>ข้อมูลสุขภาพ (ผลตรวจสุขภาพ, ประวัติการรักษา, หมู่โลหิต, การแพ้ยา/อาหาร)</li>
                    <li>ข้อมูลชีวภาพ (Biometric) เช่น สแกนใบหน้า, ลายนิ้วมือ</li>
                    <li>ประวัติอาชญากรรม</li>
                    <li>ข้อมูลการตรวจวัดระดับแอลกอฮอล์หรือสารเสพติด</li>
                    <li>ข้อมูลศาสนา เชื้อชาติ ความพิการ</li>
                </ul>

                <h5 class="mt-4">ตาราง: วัตถุประสงค์และฐานทางกฎหมายสำหรับการประมวลผลข้อมูลส่วนบุคคล</h5>
                <div class="table-responsive">
                    <table class="table table-bordered table-custom">
                        <thead class="bg-light">
                            <tr>
                                <th style="width: 30%;">ฐานทางกฎหมาย</th>
                                <th>วัตถุประสงค์ของการประมวลผลข้อมูลส่วนบุคคล</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="fw-bold">ฐานประโยชน์อันชอบธรรม<br>(Legitimate Interest)</td>
                                <td>เพื่อการบริหารจัดการทรัพยากรบุคคล, การวิเคราะห์ข้อมูลและจัดสรรกำลังคน, การพัฒนาบุคลากร, การเลื่อนตำแหน่ง, การโอนย้าย, การให้โบนัส, การปรับค่าจ้าง, การเกษียณอายุ, สวัสดิการพนักงาน (สถานพยาบาล, กิจกรรมสันทนาการ), การติดต่อสื่อสาร, การรักษาความปลอดภัย, การตรวจสอบข้อร้องเรียนและการทุจริต</td>
                            </tr>
                            <tr>
                                <td class="fw-bold">ฐานสัญญา<br>(Contract)</td>
                                <td>เพื่อจัดทำสัญญาจ้างงาน, การจ่ายค่าตอบแทน, งานทะเบียนพนักงาน, การปฏิบัติตามกฎระเบียบ, การประเมินผลการปฏิบัติงาน, การดูแลสุขภาพและความปลอดภัย, แรงงานสัมพันธ์</td>
                            </tr>
                            <tr>
                                <td class="fw-bold">ฐานการปฏิบัติตามกฎหมาย<br>(Legal Obligation)</td>
                                <td>เพื่อปฏิบัติตามกฎหมายคุ้มครองแรงงาน, ประกันสังคม, ความปลอดภัยอาชีวอนามัย, การควบคุมโรคติดต่อ และกฎหมายอื่นๆ ที่เกี่ยวข้อง</td>
                            </tr>
                            <tr>
                                <td class="fw-bold">ฐานความยินยอม<br>(Consent)</td>
                                <td>
                                    <ul class="mb-0 ps-3">
                                        <li>เพื่อทำบัตรประจำตัวพนักงาน</li>
                                        <li>เพื่อการบันทึกข้อมูลชีวภาพ (Biometric) เช่น ภาพจำลองใบหน้า, ลายนิ้วมือ</li>
                                        <li>เพื่อออกหนังสือรับรองการเป็นพนักงาน</li>
                                        <li>เพื่อยืนยันข้อมูลทางการเงินกับสถาบันการเงิน</li>
                                        <li>การตรวจสารเสพติดในร่างกาย</li>
                                        <li>เพื่อทำหนังสือมอบอำนาจ</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4>4. บุคคลที่บริษัทฯ อาจเปิดเผย และ / หรือส่งต่อข้อมูลส่วนบุคคลของท่าน</h4>
                <h5>4.1 การเปิดเผยข้อมูลภายในประเทศ</h5>
                <p>บริษัทฯ อาจเปิดเผยข้อมูลให้แก่ บริษัทในเครือ, สถาบันการศึกษา, ผู้ให้บริการตรวจสอบประวัติ, บริษัทข้อมูลเครดิต, โรงพยาบาล, สถาบันการเงิน, ผู้สอบบัญชี, หน่วยงานราชการ (เช่น กรมแรงงาน, ประกันสังคม) และคู่ค้าทางธุรกิจที่จำเป็นต่อการดำเนินงาน</p>

                <h5>4.2 การส่งหรือโอนข้อมูลไปยังต่างประเทศ</h5>
                <p>บริษัทฯ อาจส่งข้อมูลไปยังต่างประเทศในกรณีจำเป็น เช่น การใช้บริการ Cloud Server หรือ Software สำเร็จรูป โดยบริษัทฯ จะดำเนินการให้มั่นใจว่าประเทศปลายทางหรือผู้ให้บริการมีมาตรการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอและเหมาะสมตามกฎหมาย</p>

                <h4>5. การเก็บรักษา และระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</h4>
                <ul>
                    <li>บริษัทฯ มีมาตรการรักษาความปลอดภัยทั้งแบบเอกสารและอิเล็กทรอนิกส์</li>
                    <li>เก็บรักษาข้อมูลตลอดระยะเวลาที่เป็นพนักงาน และต่อเนื่องหลังจากพ้นสภาพตามความจำเป็นทางกฎหมาย (โดยทั่วไปสูงสุด 10 ปี)</li>
                    <li>เมื่อพ้นกำหนดระยะเวลา หรือหมดความจำเป็น บริษัทฯ จะดำเนินการลบหรือทำลายข้อมูลดังกล่าว</li>
                    <li>หากพนักงานถอนความยินยอม บริษัทฯ จะประมวลผลถึงแค่จุดที่ถอนความยินยอม แต่จะยังเก็บประวัติการถอนความยินยอมไว้เพื่อเป็นหลักฐาน</li>
                </ul>

                <h4>6. สิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล</h4>
                <p>ท่านมีสิทธิดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่าน ดังนี้:</p>
                <ol>
                    <li><strong>สิทธิขอเข้าถึงและรับสำเนา:</strong> ขอตรวจสอบและรับสำเนาข้อมูลส่วนบุคคลของท่าน</li>
                    <li><strong>สิทธิขอรับหรือโอนย้ายข้อมูล:</strong> ขอรับข้อมูลในรูปแบบอิเล็กทรอนิกส์หรือส่งไปยังผู้ควบคุมข้อมูลอื่น (หากทำได้ทางเทคนิค)</li>
                    <li><strong>สิทธิขอคัดค้าน:</strong> คัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลในบางกรณี (เช่น การตลาดแบบตรง, ภารกิจรัฐ)</li>
                    <li><strong>สิทธิขอลบหรือทำลาย:</strong> ขอให้ลบข้อมูลเมื่อหมดความจำเป็น, ถอนความยินยอม, หรือถูกเก็บโดยไม่ชอบด้วยกฎหมาย</li>
                    <li><strong>สิทธิขอระงับการใช้:</strong> ขอให้ระงับการใช้ข้อมูลชั่วคราวระหว่างตรวจสอบหรือแก้ไข</li>
                    <li><strong>สิทธิขอแก้ไขข้อมูล:</strong> ขอแก้ไขข้อมูลให้ถูกต้อง เป็นปัจจุบัน และสมบูรณ์</li>
                    <li><strong>สิทธิขอถอนความยินยอม:</strong> ถอนความยินยอมได้ตลอดเวลา (อาจมีผลกระทบต่อสิทธิประโยชน์บางอย่าง)</li>
                    <li><strong>สิทธิร้องเรียน:</strong> ร้องเรียนต่อหน่วยงานรัฐหากพบการฝ่าฝืนกฎหมาย</li>
                </ol>
                <p class="text-muted small">ท่านสามารถทำคำขอไปยังบริษัทฯ และบริษัทฯ จะพิจารณาแจ้งผลภายใน 30 วัน</p>

                <h4>7. แนวทางพื้นฐานในการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล</h4>
                <p>บริษัทฯ ใช้มาตรการป้องกันด้านการบริหารจัดการ (Administrative), ด้านเทคนิค (Technical), และทางกายภาพ (Physical) เพื่อป้องกันการเข้าถึงหรือเปิดเผยข้อมูลโดยมิชอบ ข้อมูลจะถูกเก็บในเครือข่ายที่มีความปลอดภัยและจำกัดสิทธิ์การเข้าถึงเฉพาะบุคคลที่เกี่ยวข้องเท่านั้น</p>

                <h4>8. การใช้ข้อมูลส่วนบุคคลตามวัตถุประสงค์เดิม</h4>
                <p>บริษัทฯ มีสิทธิเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลที่เก็บไว้ก่อนกฎหมาย PDPA บังคับใช้ต่อไปตามวัตถุประสงค์เดิม หากท่านไม่ประสงค์ให้ใช้ต่อ สามารถแจ้งขอถอนความยินยอมได้</p>

                <h4>9. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h4>
                <p>นโยบายฉบับนี้อาจมีการแก้ไขเปลี่ยนแปลง โดยบริษัทฯ จะแสดงฉบับที่เป็นปัจจุบันไว้บนเว็บไซต์ของบริษัทฯ</p>

                <h4>10. ติดต่อบริษัทฯ</h4>
                <p>หากท่านมีคำถาม ข้อสงสัย หรือมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน โปรดติดต่อบริษัทฯ ได้ที่</p>
                <div class="bg-contact p-4 rounded mt-3">
                    <p class="mb-1"><strong>เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer)</strong></p>
                    <p class="mb-1">บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด</p>
                    <p class="mb-1"><strong>ที่อยู่:</strong> 159 หมู่ที่ 9 ตำบลหนองไผ่ อำเภอเมืองศรีสะเกษ จ.ศรีสะเกษ 38070</p>
                    <p class="mb-1"><strong>หมายเลขโทรศัพท์:</strong> <a href="tel:045965988">045-965-988</a> ต่อ 03</p>
                    <p class="mb-0"><strong>อีเมล:</strong> <a href="mailto:pdpa_dpo@boonsiri.co">pdpa_dpo@boonsiri.co</a></p>
                </div>
            </div>
        </div>
    </div>
</section>



<script src="https://www.boonsiri.co.th/bootstrap/js/bootstrap.bundle.min.js"></script>
</body>
</html>
`;

export default function CookieConsent() {
  const { data, setData } = useDataContext();
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [viewingPolicy, setViewingPolicy] = useState(null);
  const [policies, setPolicies] = useState({ general: null, employee: null, candidate: null });

  // Auth State
  const [cookies] = useCookies(['session']);
  // const [currentEmployee, setCurrentEmployee] = useState(null); // เก็บข้อมูลพนักงานที่ login อยู่

  // Preferences State
  const [preferences, setPreferences] = useState({
    functional: false,
    performance: false,
    marketing: false,
    hr: false,
    generalPolicy: true,
    employeePolicy: true,
  });

  // โหมดทำงาน — 'initial' = first-time accept (POST /submit)
  //              'edit'    = แก้ optional cookies (POST /update-preferences)
  const [mode, setMode] = useState('initial');
  // มี consent อยู่แล้วในระบบ PDPA หรือไม่ (สำหรับเลือก submit vs update-preferences)
  const [hasExistingConsent, setHasExistingConsent] = useState(false);
  const [hydrating, setHydrating] = useState(false);

  // ---------------------------------------------------------
  // 1. ส่วน Auth: แกะ Cookie หา Employee Code
  // ---------------------------------------------------------
  // useEffect(() => {
  //   if (cookies.session && data?.getAllEmployees) {
  //     try {
  //       const decodedToken = jwtDecode(cookies.session);

  //       const foundEmployee = data.getAllEmployees.find(
  //         (employee) =>
  //              (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          // (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          // (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
  //           (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
  //           (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
  //           (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
  //       );
  //       // const foundEmployee = data.getAllEmployees.find(
  //       //   (employee) =>
  //       //     (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
  //       //     (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
  //       //     (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
  //       //     (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
  //       // );
  //       console.log('🚀 ~ CookieConsent ~ foundEmployee:', foundEmployee);

  //       if (foundEmployee) {
  //         // เจอตัวพนักงานแล้ว set state ไว้
  //         setCurrentEmployee((prev) =>
  //           prev?.employeeCode !== foundEmployee.employeeCode ? foundEmployee : prev
  //         );
  //       }
  //     } catch (error) {
  //       console.error('Decode token error:', error);
  //     }
  //   }
  // }, [cookies.session, data?.getAllEmployees]);

  // --- currentUser: รองรับทั้ง employee และ candidate ---
  // shape: { userType: 'employee'|'candidate', empCode: string, employee?: object }
  // empCode สำหรับ candidate ใช้ prefix CND_ เพื่อกัน collision กับรหัสพนักงาน
  const currentUser = useMemo(() => {
    if (!cookies.session) return null;

    try {
      const decodedToken = jwtDecode(cookies.session);

      // candidate: identify ผ่าน candidateId field ใน JWT
      if (decodedToken?.candidateId) {
        return {
          userType: 'candidate',
          empCode: `CND_${decodedToken.candidateId}`,
          candidateId: decodedToken.candidateId,
        };
      }

      // employee: หาใน getAllEmployees ตาม username/UserCode/email
      if (!data?.getAllEmployees) return null;
      const found = data.getAllEmployees.find(
        (employee) =>
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
      );
      if (!found) return null;
      return {
        userType: 'employee',
        empCode: found.employeeCode,
        employee: found,
      };
    } catch (error) {
      console.error('Decode token error:', error);
      return null;
    }
  }, [cookies.session, data?.getAllEmployees]);

  // backward-compat alias — มี code path เก่าที่ยังเรียก currentEmployee?.employeeCode
  // map ให้กลายเป็น { employeeCode: empCode } ผ่าน currentUser
  const currentEmployee = currentUser
    ? { ...(currentUser.employee || {}), employeeCode: currentUser.empCode }
    : null;

  // policy ที่ user คนนี้ต้อง accept
  // - employee  → [general, employee]
  // - candidate → [candidate] เท่านั้น (ไม่ใช้นโยบายทั่วไป)
  const requiredVersionIdsForUser = useMemo(() => {
    if (!currentUser) return [];
    const ids = [];
    if (currentUser.userType === 'candidate') {
      ids.push(policies.candidate?.VersionID);
    } else {
      ids.push(policies.general?.VersionID);
      ids.push(policies.employee?.VersionID);
    }
    return ids.filter((v) => typeof v === 'number');
  }, [
    currentUser?.userType,
    policies.general?.VersionID,
    policies.employee?.VersionID,
    policies.candidate?.VersionID,
  ]);

  // ---------------------------------------------------------
  // ดึงเนื้อหานโยบายจาก PDPA service ผ่าน hr-backend proxy
  // เก็บทั้ง VersionID (สำหรับ submit) และ ContentHtml (สำหรับ render)
  // ถ้าโหลดไม่สำเร็จจะ fallback ไปใช้ HTML ที่ hardcode ไว้ในไฟล์นี้
  // ---------------------------------------------------------
  useEffect(() => {
    const ac = new AbortController();
    fetch(`${import.meta.env.VITE_API_URL}/pdpa/policy/active`, { signal: ac.signal })
      .then((r) => r.json())
      .then((j) => {
        if (j?.resCode !== '0000' || !Array.isArray(j.data)) return;
        const byName = (name) => {
          const found = j.data.find((p) => (p.PolicyName || '').trim() === name);
          return found ? { VersionID: found.VersionID, ContentHtml: found.ContentHtml } : null;
        };
        setPolicies({
          general: byName('กฎความปลอดภัยทั่วไปและบทลงโทษด้านความปลอดภัย'),
          employee: byName('นโยบายความเป็นส่วนตัวสำหรับพนักงาน'),
          candidate: byName('นโยบายความเป็นส่วนตัวสำหรับผู้สมัครงาน'),
        });
      })
      .catch(() => {
        /* silent — fallback HTML covers the failure */
      });
    return () => ac.abort();
  }, []);

  // ---------------------------------------------------------
  // 2. ส่วน Consent Check: ทำงานเมื่อได้ currentEmployee + active policies มาแล้ว
  //    ใช้ /pdpa/client/get-consents เทียบ acceptedPolicies กับ active VersionIDs
  // ---------------------------------------------------------
  // ตัวกันยิงซ้ำ — key รวม sorted versionIds เผื่อมี policy version ใหม่ออกมาแล้วต้อง re-check
  const lastCheckedSignature = useRef(null);

  useEffect(() => {
    if (!currentEmployee?.employeeCode) return;

    const requiredVersionIds = requiredVersionIdsForUser;

    // รอจน /policy/active resolve ครบก่อน — ถ้ายังไม่มี VersionID ก็เทียบไม่ได้
    if (requiredVersionIds.length === 0) return;

    const empCode = currentEmployee.employeeCode;
    const signature = `${empCode}:${[...requiredVersionIds].sort((a, b) => a - b).join(',')}`;
    if (lastCheckedSignature.current === signature) return;
    lastCheckedSignature.current = signature;

    const normalizeVersionId = (item) => {
      if (typeof item === 'number') return item;
      if (typeof item === 'string') {
        const n = Number(item);
        return Number.isFinite(n) ? n : null;
      }
      if (item && typeof item === 'object') {
        // upstream /pdpa/client/get-consents ใช้ versionId (camelCase, d เล็ก)
        // ขณะที่ /pdpa/policy/active ใช้ VersionID (PascalCase) — รองรับทุกแบบ
        const raw =
          item.VersionID ??
          item.versionID ??
          item.versionId ??
          item.versionid ??
          null;
        if (typeof raw === 'number') return raw;
        if (typeof raw === 'string') {
          const n = Number(raw);
          return Number.isFinite(n) ? n : null;
        }
        return null;
      }
      return null;
    };

    const checkConsents = async () => {
      setData((prev) => ({ ...prev, spin: true }));
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/pdpa/client/get-consents`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ empCode }),
          }
        );

        if (response.ok) {
          const result = await response.json();
          if (result?.resCode === '0000' && Array.isArray(result.acceptedPolicies)) {
            const acceptedIds = new Set(
              result.acceptedPolicies
                .map(normalizeVersionId)
                .filter((v) => typeof v === 'number')
            );
            // accept ครบทุก active VersionID → ไม่โชว์ banner + flag ว่ามี consent อยู่แล้ว
            if (requiredVersionIds.every((id) => acceptedIds.has(id))) {
              setHasExistingConsent(true);
              // hydrate preferences จาก record ล่าสุด เพื่อให้ตอนกด "ตั้งค่า" จากเมนูเห็นค่าปัจจุบัน
              const latest = result.acceptedPolicies[0]?.preferences;
              if (latest && typeof latest === 'object') {
                setPreferences((prev) => ({ ...prev, ...latest, generalPolicy: true, employeePolicy: true }));
              }
              return; // finally ปิด spin ให้
            }
          }
        }
      } catch (error) {
        console.error('Error checking consents from PDPA:', error);
      } finally {
        setData((prev) => ({ ...prev, spin: false }));
      }

      // มี policy ที่ยังไม่ accept หรือ API ล้มเหลว → เด้ง banner
      setTimeout(() => setShowBanner(true), 500);
    };

    checkConsents();
  }, [
    currentEmployee?.employeeCode,
    requiredVersionIdsForUser.join(','),
  ]);

  // ---------------------------------------------------------
  // 3. เปิด modal จาก trigger ภายนอก (account-popover → context flag)
  //    โหมด edit: re-hydrate preferences สดจาก /get-consents เพื่อให้แสดงค่าปัจจุบันชัวร์
  // ---------------------------------------------------------
  useEffect(() => {
    if (!data?.cookieSettingsOpen) return;
    if (!currentEmployee?.employeeCode) {
      // user ยังไม่ได้ login / ยังโหลด employee ไม่เสร็จ → reset flag กัน loop
      setData((prev) => ({ ...prev, cookieSettingsOpen: false }));
      return;
    }

    let cancelled = false;
    const openEdit = async () => {
      setMode('edit');
      setHydrating(true);
      setData((prev) => ({ ...prev, spin: true }));
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/pdpa/client/get-consents`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ empCode: currentEmployee.employeeCode }),
          }
        );
        if (response.ok) {
          const result = await response.json();
          if (result?.resCode === '0000' && Array.isArray(result.acceptedPolicies) && result.acceptedPolicies.length > 0) {
            const latest = result.acceptedPolicies[0]?.preferences;
            if (latest && typeof latest === 'object' && !cancelled) {
              setPreferences((prev) => ({
                ...prev,
                ...latest,
                generalPolicy: true,
                employeePolicy: true,
              }));
              setHasExistingConsent(true);
            }
          }
        }
      } catch (error) {
        console.error('Failed to hydrate preferences for edit:', error);
      } finally {
        if (!cancelled) {
          setHydrating(false);
          setShowBanner(false);
          setShowModal(true);
        }
        setData((prev) => ({ ...prev, spin: false }));
      }
    };

    openEdit();
    return () => {
      cancelled = true;
    };
  }, [data?.cookieSettingsOpen, currentEmployee?.employeeCode]);

  // helper: ปิด modal + clear context flag เพื่อให้ trigger ครั้งต่อไปจาก account-popover ทำงานได้
  const handleCloseModal = () => {
    setShowModal(false);
    if (data?.cookieSettingsOpen) {
      setData((prev) => ({ ...prev, cookieSettingsOpen: false }));
    }
    setMode('initial');
  };

  // ---------------------------------------------------------
  // Revoke flow — POST /pdpa/client/revoke ต่อ active VersionID → logout
  // ---------------------------------------------------------
  const [revokeConfirmOpen, setRevokeConfirmOpen] = useState(false);
  const [revoking, setRevoking] = useState(false);
  const isRevokingRef = useRef(false);

  const handleRevoke = async () => {
    if (isRevokingRef.current || !currentUser?.empCode) return;
    const versionIds = requiredVersionIdsForUser;
    if (versionIds.length === 0) {
      console.warn('Revoke skipped: no active VersionID available yet');
      return;
    }

    isRevokingRef.current = true;
    setRevoking(true);
    setData((prev) => ({ ...prev, spin: true }));

    const userType = currentUser?.userType === 'candidate' ? 'applicant' : 'employee';

    try {
      await Promise.allSettled(
        versionIds.map((versionID) =>
          fetch(`${import.meta.env.VITE_API_URL}/pdpa/client/revoke`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              empCode: currentUser.empCode,
              versionID,
              reason: 'User requested via settings',
              userType,
            }),
          })
        )
      );
    } catch (error) {
      console.error('Revoke PDPA consent failed:', error);
    } finally {
      // ล้าง session แล้วพากลับหน้า login ตามประเภท user
      try {
        // เคลียร์ session cookie ทั้ง path/domain ที่เป็นไปได้
        document.cookie = 'session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = 'imageProfile=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      } catch (e) {
        // best effort
      }
      const loginPath = currentUser.userType === 'candidate' ? '/loginCandidate' : '/login';
      window.location.href = loginPath;
    }
  };
  // ---------------------------------------------------------
  // Actions
  // ---------------------------------------------------------

  const handleToggle = (key) => {
    if (key === 'generalPolicy' || key === 'employeePolicy') return;
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleAcceptAll = () => {
    const allAccepted = {
      functional: true,
      performance: true,
      marketing: true,
      hr: true,
      generalPolicy: true,
      employeePolicy: true,
    };
    setPreferences(allAccepted);
    // policies หลัก required เสมอ — status เป็น ACCEPTED, ความต่างคือ preferences (cookies เสริม)
    saveConsent('ACCEPTED', allAccepted);
  };

  const handleRejectAll = () => {
    const rejectOptional = {
      functional: false,
      performance: false,
      marketing: false,
      hr: false,
      generalPolicy: true,
      employeePolicy: true,
    };
    setPreferences(rejectOptional);
    saveConsent('ACCEPTED', rejectOptional);
  };

  // กัน submit ซ้อนกันตอนกดปุ่มถี่ ๆ (PDPA backend ไม่มี dedup ฝั่งของมันเอง)
  const isSavingRef = useRef(false);

  const saveConsent = async (status, currentPreferences = preferences) => {
    if (isSavingRef.current) return;
    if (!currentEmployee?.employeeCode) return;

    // เลือก endpoint: edit-mode + มี consent อยู่แล้ว → /update-preferences (PATCH-like)
    // ในกรณีอื่น → /submit (first-time accept)
    const isEdit = mode === 'edit' && hasExistingConsent;
    const endpoint = isEdit
      ? `${import.meta.env.VITE_API_URL}/pdpa/client/update-preferences`
      : `${import.meta.env.VITE_API_URL}/pdpa/client/submit`;

    // ปิด banner/modal ทันทีเพื่อ UX — error จะ silent fail
    setShowBanner(false);
    setShowModal(false);
    // ถ้าเปิดมาจาก context flag ให้ clear ด้วย
    if (data?.cookieSettingsOpen) {
      setData((prev) => ({ ...prev, cookieSettingsOpen: false }));
    }
    isSavingRef.current = true;

    // ส่งทุก VersionID ที่ active ตามประเภท user (employee/candidate)
    const versionIds = requiredVersionIdsForUser;

    if (versionIds.length === 0) {
      // ไม่มี VersionID = /policy/active ยังไม่ resolve หรือ fail
      console.warn('PDPA save skipped: no active VersionID available yet');
      isSavingRef.current = false;
      return;
    }

    // map userType ตามประเภท user — admin UI ใช้ค่านี้แสดง badge "พนักงาน"/"ผู้สมัคร"
    const userType = currentUser?.userType === 'candidate' ? 'applicant' : 'employee';

    try {
      await Promise.all(
        versionIds.map((versionID) =>
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
              isEdit
                ? {
                    empCode: currentEmployee.employeeCode,
                    versionID,
                    preferences: currentPreferences,
                    userType,
                  }
                : {
                    empCode: currentEmployee.employeeCode,
                    versionID,
                    status,
                    preferences: currentPreferences,
                    userType,
                  }
            ),
          })
        )
      );
      setHasExistingConsent(true);
    } catch (error) {
      console.error(`Failed to save PDPA consent (${isEdit ? 'update' : 'submit'}):`, error);
    } finally {
      isSavingRef.current = false;
      setMode('initial');
    }
  };

  // ---------------------------------------------------------
  // Render
  // ---------------------------------------------------------

  // ถ้าไม่มีการ Login (ไม่มี currentEmployee) หรือ ไม่ให้แสดง -> return null
  if (!currentEmployee || (!showBanner && !showModal)) return null;

  return (
    <div className="cookie-pdpa-container">
      {/* --- Banner --- */}
      <div className={`cookie-banner ${showBanner && !showModal ? 'active' : ''}`}>
        <div className="banner-container">
          <div className="banner-content">
            <h3 className="banner-title">
              <CookieIcon sx={{ marginRight: 1, marginBottom: 0.5 }} />
              การตั้งค่าคุกกี้และนโยบายความเป็นส่วนตัว
            </h3>
            <p>
              เว็บไซต์นี้ใช้คุกกี้และมีการประมวลผลข้อมูลส่วนบุคคลของ
              <strong>
                {' '}
                {currentUser?.userType === 'candidate' ? 'ผู้สมัครงาน' : 'พนักงาน'}{' '}
              </strong>
              เพื่อให้สอดคล้องกับ PDPA ท่านต้องยอมรับนโยบายบริษัทเพื่อเข้าใช้งานระบบ
            </p>
          </div>
          <div className="banner-actions">
            <button className="pdpa-btn pdpa-btn-outline" onClick={() => setShowModal(true)}>
              <TuneIcon sx={{ fontSize: 20 }} /> อ่านรายละเอียดและตั้งค่า
            </button>
            <button className="pdpa-btn pdpa-btn-primary" onClick={handleAcceptAll}>
              <CheckIcon sx={{ fontSize: 20 }} /> ยอมรับทั้งหมด
            </button>
          </div>
        </div>
      </div>

      {/* --- Main Settings Modal --- */}
      <div className={`pdpa-modal-overlay ${showModal ? 'active' : ''}`} style={{ zIndex: 9999 }}>
        <div className="pdpa-modal-card">
          <div className="pdpa-modal-header">
            <div className="pdpa-modal-title">
              <h2>
                {mode === 'edit'
                  ? 'แก้ไขการตั้งค่าคุกกี้และ PDPA'
                  : 'ศูนย์การตั้งค่าความเป็นส่วนตัว'}
              </h2>
            </div>
            <CloseIcon
              className="pdpa-close-icon"
              onClick={handleCloseModal}
              sx={{ cursor: 'pointer', color: '#64748b' }}
            />
          </div>

          <div className="pdpa-modal-body">
            <p className="mb-4 text-muted" style={{ fontSize: '0.9rem' }}>
              {(() => {
                const ctx = currentUser?.userType === 'candidate' ? 'การใช้บริการสมัครงาน' : 'การปฏิบัติงาน';
                if (mode === 'edit') {
                  return hydrating
                    ? 'กำลังโหลดการตั้งค่าปัจจุบัน...'
                    : `คุณสามารถปรับแต่งคุกกี้เสริมได้ตามต้องการ นโยบายพื้นฐานยังคงต้องเปิดไว้เพื่อ${ctx}`;
                }
                return `ท่านต้องยอมรับนโยบายพื้นฐานของบริษัทเพื่อ${ctx} สำหรับคุกกี้อื่นๆ ท่านสามารถเลือกปรับแต่งได้ตามความต้องการ`;
              })()}
            </p>

            {/* --- 1. นโยบายทั่วไป (Forced) — เฉพาะ employee --- */}
            {currentUser?.userType !== 'candidate' && (
              <div className="pdpa-cookie-item required-item">
                <div className="pdpa-cookie-icon">
                  <GavelIcon sx={{ fontSize: 28 }} />
                </div>
                <div className="pdpa-cookie-details">
                  <div className="pdpa-cookie-head">
                    <span className="pdpa-cookie-title">นโยบายทั่วไป (General Policy)</span>
                    <div className="d-flex align-items-center">
                      <span className="pdpa-status-badge required me-2">เปิดตลอดเวลา</span>
                      <label className="pdpa-switch disabled">
                        <input type="checkbox" checked={true} disabled />
                        <span className="pdpa-slider"></span>
                      </label>
                    </div>
                  </div>
                  <p className="pdpa-cookie-desc">
                    กฎระเบียบเรื่องการคุ้มครองข้อมูลและความปลอดภัยภายในองค์กร
                  </p>
                  <button className="btn-link-policy" onClick={() => setViewingPolicy('general')}>
                    อ่านนโยบายฉบับเต็ม <ArrowIcon sx={{ fontSize: 12, marginLeft: '5px' }} />
                  </button>
                </div>
              </div>
            )}

            {/* --- 2. นโยบายความเป็นส่วนตัว (Forced) — สลับตามประเภท user --- */}
            {currentUser?.userType === 'candidate' ? (
              <div className="pdpa-cookie-item required-item">
                <div className="pdpa-cookie-icon">
                  <DescriptionIcon sx={{ fontSize: 28 }} />
                </div>
                <div className="pdpa-cookie-details">
                  <div className="pdpa-cookie-head">
                    <span className="pdpa-cookie-title">นโยบายความเป็นส่วนตัวผู้สมัครงาน</span>
                    <div className="d-flex align-items-center">
                      <span className="pdpa-status-badge required me-2">เปิดตลอดเวลา</span>
                      <label className="pdpa-switch disabled">
                        <input type="checkbox" checked={true} disabled />
                        <span className="pdpa-slider"></span>
                      </label>
                    </div>
                  </div>
                  <p className="pdpa-cookie-desc">
                    รายละเอียดการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของผู้สมัครงานตาม PDPA
                  </p>
                  <button className="btn-link-policy" onClick={() => setViewingPolicy('candidate')}>
                    อ่านนโยบายฉบับเต็ม <ArrowIcon sx={{ fontSize: 12, marginLeft: '5px' }} />
                  </button>
                </div>
              </div>
            ) : (
              <div className="pdpa-cookie-item required-item">
                <div className="pdpa-cookie-icon">
                  <DescriptionIcon sx={{ fontSize: 28 }} />
                </div>
                <div className="pdpa-cookie-details">
                  <div className="pdpa-cookie-head">
                    <span className="pdpa-cookie-title">นโยบายความเป็นส่วนตัวพนักงาน</span>
                    <div className="d-flex align-items-center">
                      <span className="pdpa-status-badge required me-2">เปิดตลอดเวลา</span>
                      <label className="pdpa-switch disabled">
                        <input type="checkbox" checked={true} disabled />
                        <span className="pdpa-slider"></span>
                      </label>
                    </div>
                  </div>
                  <p className="pdpa-cookie-desc">
                    รายละเอียดการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของพนักงานตาม PDPA
                  </p>
                  <button className="btn-link-policy" onClick={() => setViewingPolicy('employee')}>
                    อ่านนโยบายฉบับเต็ม <ArrowIcon sx={{ fontSize: 12, marginLeft: '5px' }} />
                  </button>
                </div>
              </div>
            )}

            <hr className="my-4" style={{ borderColor: '#e2e8f0' }} />
            <h5 className="mb-3" style={{ fontSize: '1rem', fontWeight: 'bold', color: '#334155' }}>
              การตั้งค่าคุกกี้
            </h5>

            {/* 3. Necessary */}
            <div className="pdpa-cookie-item">
              <div className="pdpa-cookie-icon">
                <SecurityIcon sx={{ fontSize: 28 }} />
              </div>
              <div className="pdpa-cookie-details">
                <div className="pdpa-cookie-head">
                  <span className="pdpa-cookie-title">คุกกี้ที่จำเป็น (Strictly Necessary)</span>
                  <span className="pdpa-status-badge">เปิดตลอดเวลาเวลา</span>
                </div>
                <p className="pdpa-cookie-desc">จำเป็นอย่างยิ่งสำหรับการทำงานพื้นฐานของเว็บไซต์</p>
              </div>
            </div>

            {/* 4. HR & Recruitment — เฉพาะ employee (cookie ผูกกับ flow พนักงาน) */}
            {currentUser?.userType !== 'candidate' && (
              <div className="pdpa-cookie-item">
                <div className="pdpa-cookie-icon">
                  <BadgeIcon sx={{ fontSize: 28 }} />
                </div>
                <div className="pdpa-cookie-details">
                  <div className="pdpa-cookie-head">
                    <span className="pdpa-cookie-title">ระบบงานบุคคล (HR & Recruitment)</span>
                    <label className="pdpa-switch">
                      <input
                        type="checkbox"
                        checked={preferences.hr}
                        onChange={() => handleToggle('hr')}
                      />
                      <span className="pdpa-slider"></span>
                    </label>
                  </div>
                  <p className="pdpa-cookie-desc">สำหรับการจัดการรับสมัครงานและข้อมูลพนักงาน</p>
                </div>
              </div>
            )}

            {/* 5. Functional */}
            <div className="pdpa-cookie-item">
              <div className="pdpa-cookie-icon">
                <LayersIcon sx={{ fontSize: 28 }} />
              </div>
              <div className="pdpa-cookie-details">
                <div className="pdpa-cookie-head">
                  <span className="pdpa-cookie-title">คุกกี้เพื่อการทำงาน (Functional)</span>
                  <label className="pdpa-switch">
                    <input
                      type="checkbox"
                      checked={preferences.functional}
                      onChange={() => handleToggle('functional')}
                    />
                    <span className="pdpa-slider"></span>
                  </label>
                </div>
                <p className="pdpa-cookie-desc">จดจำการตั้งค่าภาษาและภูมิภาค</p>
              </div>
            </div>

            {/* 6. Performance */}
            <div className="pdpa-cookie-item">
              <div className="pdpa-cookie-icon">
                <PieChartIcon sx={{ fontSize: 28 }} />
              </div>
              <div className="pdpa-cookie-details">
                <div className="pdpa-cookie-head">
                  <span className="pdpa-cookie-title">คุกกี้ประสิทธิภาพ (Performance)</span>
                  <label className="pdpa-switch">
                    <input
                      type="checkbox"
                      checked={preferences.performance}
                      onChange={() => handleToggle('performance')}
                    />
                    <span className="pdpa-slider"></span>
                  </label>
                </div>
                <p className="pdpa-cookie-desc">เก็บสถิติการใช้งานเพื่อปรับปรุงเว็บไซต์</p>
              </div>
            </div>

            {/* 7. Marketing */}
            <div className="pdpa-cookie-item">
              <div className="pdpa-cookie-icon">
                <CampaignIcon sx={{ fontSize: 28 }} />
              </div>
              <div className="pdpa-cookie-details">
                <div className="pdpa-cookie-head">
                  <span className="pdpa-cookie-title">คุกกี้การตลาด (Targeting)</span>
                  <label className="pdpa-switch">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={() => handleToggle('marketing')}
                    />
                    <span className="pdpa-slider"></span>
                  </label>
                </div>
                <p className="pdpa-cookie-desc">แสดงโฆษณาที่เกี่ยวข้องกับความสนใจ</p>
              </div>
            </div>
          </div>

          <div className="pdpa-modal-footer">
            <div className="pdpa-footer-group">
              {mode === 'edit' && hasExistingConsent && (
                <button
                  className="pdpa-btn pdpa-btn-outline"
                  style={{ color: '#dc2626', borderColor: '#fecaca' }}
                  onClick={() => setRevokeConfirmOpen(true)}
                  disabled={revoking}
                >
                  ยกเลิกความยินยอม
                </button>
              )}
              <button className="pdpa-btn pdpa-btn-outline" onClick={handleRejectAll}>
                ปฏิเสธ (คุกกี้เสริม)
              </button>
              <button
                className="pdpa-btn pdpa-btn-outline"
                onClick={() =>
                  setPreferences({
                    functional: true,
                    performance: true,
                    marketing: true,
                    hr: true,
                    generalPolicy: true,
                    employeePolicy: true,
                  })
                }
              >
                อนุญาตทั้งหมด
              </button>
            </div>
            <div className="pdpa-footer-group">
              <button className="pdpa-btn pdpa-btn-primary" onClick={() => saveConsent('ACCEPTED')}>
                บันทึกการตั้งค่า
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* --- Detail Policy Modal (Stacked) --- */}
      {viewingPolicy && (
        <div className="pdpa-modal-overlay active" style={{ zIndex: 10000 }}>
          <div className="pdpa-modal-card policy-detail-card">
            <div className="pdpa-modal-header">
              <div className="pdpa-modal-title">
                <h2>
                  {viewingPolicy === 'general'
                    ? 'นโยบายทั่วไป'
                    : viewingPolicy === 'candidate'
                    ? 'นโยบายความเป็นส่วนตัวสำหรับผู้สมัครงาน'
                    : 'นโยบายความเป็นส่วนตัวสำหรับพนักงาน'}
                </h2>
              </div>
              <CloseIcon
                className="pdpa-close-icon"
                onClick={() => setViewingPolicy(null)}
                sx={{ cursor: 'pointer', color: '#64748b' }}
              />
            </div>
            <div className="pdpa-modal-body" style={{ backgroundColor: '#fff' }}>
              <div
                className="policy-html-content"
                dangerouslySetInnerHTML={{
                  __html:
                    viewingPolicy === 'general'
                      ? policies.general?.ContentHtml ?? GENERAL_POLICY_CONTENT
                      : viewingPolicy === 'candidate'
                      ? policies.candidate?.ContentHtml ?? EMPLOYEE_POLICY_CONTENT
                      : policies.employee?.ContentHtml ?? EMPLOYEE_POLICY_CONTENT,
                }}
              />
            </div>
            <div className="pdpa-modal-footer justify-content-end">
              <button className="pdpa-btn pdpa-btn-primary" onClick={() => setViewingPolicy(null)}>
                รับทราบ
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- Revoke Confirm Dialog --- */}
      {revokeConfirmOpen && (
        <div className="pdpa-modal-overlay active" style={{ zIndex: 10001 }}>
          <div
            className="pdpa-modal-card"
            style={{ maxWidth: 480, margin: 'auto' }}
          >
            <div className="pdpa-modal-header">
              <div className="pdpa-modal-title">
                <h2 style={{ color: '#dc2626' }}>ยืนยันการยกเลิกความยินยอม</h2>
              </div>
              {!revoking && (
                <CloseIcon
                  className="pdpa-close-icon"
                  onClick={() => setRevokeConfirmOpen(false)}
                  sx={{ cursor: 'pointer', color: '#64748b' }}
                />
              )}
            </div>
            <div className="pdpa-modal-body">
              <p style={{ marginBottom: 12, color: '#334155' }}>
                การยกเลิกความยินยอมจะลบสิทธิ์การใช้งานระบบของท่าน
              </p>
              <ul style={{ paddingLeft: 20, color: '#64748b', fontSize: '0.9rem', lineHeight: 1.6 }}>
                <li>ระบบจะยกเลิกความยินยอมทุก policy ที่ active ({requiredVersionIdsForUser.length} ฉบับ)</li>
                <li>ท่านจะถูก logout ออกจากระบบทันที</li>
                <li>หากต้องการกลับมาใช้งาน ต้อง login และยอมรับนโยบายใหม่</li>
              </ul>
            </div>
            <div className="pdpa-modal-footer">
              <div className="pdpa-footer-group">
                <button
                  className="pdpa-btn pdpa-btn-outline"
                  onClick={() => setRevokeConfirmOpen(false)}
                  disabled={revoking}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="pdpa-footer-group">
                <button
                  className="pdpa-btn pdpa-btn-primary"
                  style={{ background: '#dc2626' }}
                  onClick={handleRevoke}
                  disabled={revoking}
                >
                  {revoking ? 'กำลังยกเลิก...' : 'ยืนยันการยกเลิก'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Inline Styles for new elements (Optional if not in CSS file) */}
      <style>{`
        /* ส่วนที่แก้: เพิ่ม padding และจัดระยะห่าง */
        .required-item {
            background-color: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            padding: 16px; /* เพิ่ม Padding เพื่อไม่ให้เนื้อหาติดขอบ */
            margin-bottom: 12px; /* เพิ่มระยะห่างระหว่างกล่อง */
            display: flex; /* จัด icon กับเนื้อหาให้ขนานกัน */
            align-items: flex-start; /* ให้ icon อยู่บนสุดเสมอถ้ายาว */
            gap: 12px; /* ระยะห่างระหว่าง icon กับ text */
        }
        
        /* ปรับส่วน icon ไม่ให้โดนบีบ */
        .required-item .pdpa-cookie-icon {
            flex-shrink: 0;
            margin-top: 2px;
        }

        /* ปรับส่วนรายละเอียดให้เต็มพื้นที่ */
        .required-item .pdpa-cookie-details {
            flex-grow: 1;
        }

        /* Badge เปิดตลอดเวลา */
        .pdpa-status-badge.required {
            background-color: #e0f2fe;
            color: #0284c7;
            border: 1px solid #bae6fd;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 0.75rem;
            white-space: nowrap;
        }

        .pdpa-switch.disabled {
            opacity: 0.6;
            cursor: not-allowed;
            pointer-events: none;
        }

        /* ปุ่มอ่านนโยบาย */
        .btn-link-policy {
            background: none;
            border: none;
            color: #0d6efd;
            font-size: 0.9rem;
            padding: 0;
            margin-top: 8px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            text-decoration: none;
            font-weight: 500;
            font-family: 'Noto Sans Thai', sans-serif;
        }
        .btn-link-policy:hover {
            text-decoration: underline;
        }

        /* Modal อ่านนโยบายฉบับเต็ม */
        .policy-detail-card {
            max-width: 800px;
            width: 90%;
            height: 85vh; /* ความสูงของ Modal */
            display: flex;
            flex-direction: column;
        }
        
        /* เนื้อหา HTML ใน Modal รายละเอียด */
        .policy-html-content {
            padding: 10px; /* เพิ่ม padding ให้เนื้อหาข้างในไม่ติดขอบ */
        }
        .policy-html-content h3 { font-size: 1.25rem; color: #1e293b; margin-top: 0;}
        .policy-html-content h5 { font-size: 1rem; color: #334155; margin-bottom: 0.5rem; margin-top: 1.5rem; }
        .policy-html-content ul { padding-left: 1.2rem; font-size: 0.95rem; color: #475569; }
        .policy-html-content p { font-size: 0.95rem; color: #475569; margin-bottom: 1rem; }
      `}</style>
    </div>
  );
}
